var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTumblrMobileShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 4,
  viewBox: "0 0 17 4",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4m6.5 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4M15 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
})));
export default SvgTumblrMobileShare;